import { Component, OnInit, OnDestroy } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { customerConfig } from '@uxdf/direct-shared-lib';

import { InvoicesState } from '../../../../redux/reducers/invoices/reducers-invoices';
import { __config_invoice, invoicesSelector } from '../../../../redux/reducers';
import { GetInvoices, SortInvoicesInit } from '../../../../redux/actions/invoices/actions-invoices';
import { Sorting } from '../../../../redux/models/invoices/invoices.model';
import { ModularInvoicesConfig } from '../../../../redux/models/invoices/invoicesConfig.model';
import { mockData } from './documents.mockData';
import { isOn } from 'feature-toggle-service';

@Component({
  standalone: false,
  selector: 'app-invoice-documents',
  templateUrl: './documents.component.html'
})
export class DocumentsComponent implements OnInit, OnDestroy {
  public invoicesState$: Observable<InvoicesState>;
  public invoicesConfigState$: Observable<ModularInvoicesConfig>;
  storeCode;
  readonly accountInvoicesTableDate = $localize`:@@documents.accountInvoicesTableDate:Date`;
  readonly accountOrdersDetailsDownloadPdf = $localize`:@@documents.accountOrdersDetailsDownloadPdf:Download PDF`;
  invoiceData= mockData;
  enableNewInvoiceDisplay= isOn('AMADEUS_DIRECT_INVOICES_A');
  private customerConfigSubscription: Subscription;
  isSalesView = false;

  constructor(
    private readonly store: Store<InvoicesState>
  ) {
  }

  ngOnInit() {
    this.customerConfigSubscription = this.store.pipe(select(customerConfig)).subscribe(response => {
      if (response.customerConfig && !response.isLoading) {
        this.invoicesConfigState$ = this.store.pipe(select(__config_invoice));
        this.store.dispatch(new GetInvoices());
        this.invoicesState$ = this.store.pipe(select(invoicesSelector));
      }
      this.isSalesView = response.customerConfig.is_salesView;
    });
  }

  ngOnDestroy() {
    this.customerConfigSubscription.unsubscribe();
  }

  public sort(direction: Sorting) {
    direction = direction === 'ASC' ? Sorting.desc : Sorting.asc;
    this.store.dispatch(new SortInvoicesInit(direction));
  }
}
